// Button ATC in preview popup
window.customallHandlePreviewAddToCart = true;

// Cart drawer
window.cartType = 'mini-cart';
window.addToCartCallback = (cartItems) => {
    try {
        const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
        const sectionQuery = {
            'cart-drawer': {
                source: 'cart-drawer',
                target: 'cart-drawer'
            }, 
            'cart-icon-bubble': {
                source: '#shopify-section-cart-icon-bubble',
                target: '#cart-icon-bubble'
            }
        };
        fetch(`${routes.cart_url}?sections=${sectionIds.join(',')}`)
            .then((response) => response.json())
            .then((sections) => {
                for (const sectionId of sectionIds) {
                    const htmlString = sections[sectionId];
                    const html = new DOMParser().parseFromString(htmlString, 'text/html');
                    const sourceElement = html.querySelector(`${sectionQuery[sectionId].source}`);
                    const targetElement = document.querySelector(`${sectionQuery[sectionId].target}`);
                    if (sectionId == 'cart-icon-bubble') {
                        targetElement.innerHTML = sourceElement.innerHTML;
                    } else if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                    }
                }
                const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
                if (theme_cart) theme_cart.open();
            })
            .catch((e) => {
                console.error('Error updating cart sections:', e);
            });
    } catch (error) {
        console.log('error', error)
    }
}